const isMobile = () => window.innerWidth < 768;

const updateVideoAutoplayClass = (figure) => {
  const videos = figure.querySelectorAll('video');
  
  const dontAutoplay = figure.dataset.dontAutoplay === 'true';
  const dontAutoplayMob = figure.dataset.dontAutoplaymob === 'true';
  
  const shouldAutoplay = isMobile() ? dontAutoplayMob : dontAutoplay;

  videos.forEach(video => {
    if (shouldAutoplay) {
      video.classList.add('js-video-plays-in-view');
    } else {
      video.classList.remove('js-video-plays-in-view');
      // Pause video if it's playing
      if (!video.paused) {
        video.pause();
      }
    }
  });
};

// Initialize all media grid figures
const initMediaGridVideos = () => {
  const figures = document.querySelectorAll('.media-grid__figure');
  figures.forEach(updateVideoAutoplayClass);
};

const initVideoPlayInView = (video) => {
  // Skip if already initialized
  if (video.dataset.videoInitialized) return;
  video.dataset.videoInitialized = 'true';

  // We can only control playback without interaction if video is muted
  video.muted = true;
  video.dataset.userPaused = 'false';

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.intersectionRatio <= 0.1 && !video.paused) {
          video.dataset.internalPause = 'true';
          video.pause();
        } 
        else if (
          entry.intersectionRatio > 0.1 &&
          video.paused &&
          video.dataset.userPaused === 'false'
        ) {
          const playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise.catch((error) => {
              console.log("Video play prevented:", error);
            });
          }
        }
      }
    },
    { threshold: [0.1, 0.5] }
  );

  observer.observe(video);
  video.addEventListener('pause', () => {
    if (video.dataset.internalPause !== 'true') {
      video.dataset.userPaused = 'true';
    }
    video.dataset.internalPause = '';
  });
  video.addEventListener('play', () => {
    video.dataset.userPaused = 'false';
  });
};

// Initialize existing videos
const initAllVideos = () => {
  const videos = document.querySelectorAll(".js-video-plays-in-view");
  for (const video of videos) {
    initVideoPlayInView(video);
  }
};

const initialize = () => {
  initMediaGridVideos();
  initAllVideos();
};

// Run on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initialize);
} else {
  initialize();
}

// Handle window resize to update classes for mobile/desktop switch
let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    initMediaGridVideos();
    initAllVideos();
  }, 250);
});

const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node.nodeType === 1) {
        // Check for media grid figures
        if (node.classList?.contains('media-grid__figure')) {
          updateVideoAutoplayClass(node);
        }
        const figures = node.querySelectorAll?.('.media-grid__figure');
        if (figures) {
          figures.forEach(updateVideoAutoplayClass);
        }

        // Check if the node itself is a video
        if (node.classList?.contains('js-video-plays-in-view')) {
          initVideoPlayInView(node);
        }
        // Check for videos within the added node
        const videos = node.querySelectorAll?.('.js-video-plays-in-view');
        if (videos) {
          for (const video of videos) {
            initVideoPlayInView(video);
          }
        }
      }
    }
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});
